<video controls>
    <source [src]="value+cid">
</video>